import type SmimeAttachmentType from '../store/schema/SmimeAttachmentType';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';

/**
 * Determines whether an attachment belongs to smime attachment type or not
 * @param attachment the attachment object
 */
export default function isSmimeAttachmentType(
    attachment: AttachmentType
): attachment is SmimeAttachmentType {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'boolean | undefined' is not assignable to type 'boolean'.
    // @ts-expect-error
    return attachment?.AttachmentId && isSmimeAttachment(attachment.AttachmentId.Id);
}

export function isSmimeAttachment(id: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (21,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return id && id.indexOf('smime-') !== -1;
}
